<template>
  <div class="content-item">
    <div class="gift-top-bg">
      <p class="rule-title mt-24 mb-16">
        <span class="point-icon"></span>活动期间，您可分享活动链接邀请同事一起学，受邀人通过您分享的链接学习课程且已认证为恒生客户，即算邀请成功。
        （活动期间，若受邀人点击您的邀学链接前已有学习记录/已点击过他人分享的此活动链接，则不计入您的邀请战绩。）
      </p>
      <p class="rule-title rule-title-dark">
        ·每成功邀请一人计1个积分，积分可兑换下方奖品。
      </p>
      <p class="rule-title rule-title-dark">
        ·每兑换一份奖品，将扣除相应的积分，兑换日期截止到<span class="rule-title-dark">2023年1月6日</span>
      </p>
      <div class="invitation-btn">
        <!-- <span class="left-input">{{ shareUrl }}</span> -->
        <input type="text" class="left-input" :value="shareUrl" readonly></input>
        <span class="right-btn" @click="copyLink">复制邀请链接</span>
      </div>
    </div>
    <div class="tab3">
      <div class="left">
        <p class="rule-sub-title rule-number">
          <span class="square-bg"></span>
          已成功邀请{{ pointInfo.obtain_amount }}人（剩余<span class="number">{{
            pointInfo.remain_amount
          }}</span>积分）
        </p>

        <div class="exchange-item" v-for="list in prizeList" :key="'exchange' + list.prize_id">
          <div class="exchange-left">
            <p class="rule-title">
              <span class="point-icon-sm"></span>
              {{ list.point_amount }}积分兑换{{ list.prize_name }}
            </p>
            <p class="rule-title">
              <span class="point-icon-sm " style="visibility: hidden;"></span>
              共{{ list.prize_num }}份，先到先得
              <span class="number" :class="{
                  disable:
                    pointInfo.remain_amount < list.point_amount ||
                    list.remain_num <= 0
                }">
                ({{ list.remain_num }}/{{ list.prize_num }})</span>
            </p>
          </div>
          <div class="exchange-btn disable btn" v-if="
              pointInfo.remain_amount < list.point_amount ||
                list.remain_num <= 0
            ">
            立即兑换
          </div>
          <div class="exchange-btn btn" v-else @click="doDraw(list)">
            立即兑换
          </div>
        </div>
      </div>
      <div class="right">
        <div class="rule-sub-title">
          <span class="square-bg"></span>
          我的邀请战绩
        </div>
        <div class="no-data" v-if="inviteRankList.length == 0">邀请同事一起来学习吧</div>
        <ul class="rank-list-box" v-else>
          <li class="rule-con rule-con-title">
            <span class="col1">受邀人昵称</span>
            <span class="col2">邀请状态</span>
          </li>
        </ul>
        <div v-show="inviteRankList.length > 0" class="list-box">
          <li class="rule-con" v-for="item in inviteRankList" :key="`inviteRank_${item.rank_no}`">
            <span class="col1">{{ item.nick_name }}</span>
            <span class="col2" :class="{ highlight: item.status=='2' }">{{ item.status | mapStatus }}</span>
          </li>
        </div>
        <h-page class="page-content" v-if="page.total>7" :total="page.total" :current="page.current" :page-size="page.pageSize" show-total @on-change="pageChange" @on-page-size-change="pageSizeChange" />
      </div>
    </div>

  </div>
</template>
<script>
import {
  sharing,
  redeemprize,
  getprizelist,
  getuserpoint,
  myInviteRecord,
} from "@/api/uPlusApi/learning.js";
export default {
  name: "GiftOfInvite",
  props: {
    shareUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // shareUrl: "",
      shareAction: "studyStar",
      prizeList: [],
      pointInfo: {}, // 积分信息
      exchangeDone: true, // 奖品兑换接口是否调用完成
      inviteRankList: [],
      page: {
        total: 0,
        current: 1,
        pageSize: 20,
      },
    };
  },
  filters:{
    mapStatus(val){
    const map={
      0:'未学习',
      1:'未认证',
      2:'邀请成功'
    }
    return map[val]|| '--'
    }
  },
  methods: {
    async doDraw(list) {
      if (!this.exchangeDone) {
        return;
      }
      this.exchangeDone = false;
      try {
        const res = await redeemprize({ prize_id: list.prize_id });
        this.getUserPoint();
        this.getPrizeList();
        this.exchangeDone = true;
        if (res.success) {
          this.$hMessage.success("兑换成功");
        }else{
          this.$hMessage.error(res.error_info);
        }
      } catch (e) {
        this.exchangeDone = true;
      }
    },
    pageChange(index) {
      this.page.current = index;
      this.OnloadInviteRank();
    },
    OnloadInviteRank() {
      const params = {
        page_size: 20,
        page_no: this.page.current,
        activity_id: "studyStar",
      };
      myInviteRecord(params)
        .then((res) => {
          // res = {
          //   total: 30,
          //   rows: [
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //     {
          //       auth_id: "248047173529243648",
          //       nick_name: "东吴-王旭",
          //       status: "0",
          //     },
          //   ],
          // };
          if (!res) return;
          this.inviteRankList = res.rows || [];
          this.page.total = res.total;
        })
        .catch(() => {})
        .finally(() => {});
    },
    copyLink() {
      this.$emit('copy')
      // let url = p;
      // let oInput = document.createElement("input");
      // oInput.value = this.shareUrl;
      // document.body.appendChild(oInput);
      // oInput.select(); // 选择对象;
      // document.execCommand("Copy");
      // this.$hMessage.success({
      //   content: "复制成功",
      //   successTop: 500,
      // });
      // document.body.removeChild(oInput)
    },
    async getUserPoint() {
      const res = await getuserpoint();
      this.pointInfo = res || {};
    },
    // 获取奖品列表
    async getPrizeList() {
      const res = await getprizelist();
      // const res = {
      //   total: 4,
      //   rows: [
      //     {
      //       prize_id: 600,
      //       prize_name: "5000U豆",
      //       prize_num: 100,
      //       remain_num: 0,
      //       point_amount: 1,
      //       prize_image: "",
      //     },
      //     {
      //       prize_id: 601,
      //       prize_name: "花王眼罩",
      //       prize_num: 25,
      //       remain_num: 1,
      //       point_amount: 2,
      //       prize_image: "",
      //     },
      //     {
      //       prize_id: 602,
      //       prize_name: "萌趣大肚杯",
      //       prize_num: 10,
      //       remain_num: 0,
      //       point_amount: 5,
      //       prize_image: "",
      //     },
      //     {
      //       prize_id: 603,
      //       prize_name: "筋膜枪",
      //       prize_num: 10,
      //       remain_num: 0,
      //       point_amount: 10,
      //       prize_image: "",
      //     },
      //   ],
      // };
      if (res.rows && res.rows.length) {
        this.prizeList = res.rows || [];
      }
    },
    // getShareLink() {
    //   const shareParams = {
    //     shareTitle: 'U+年度学习之星',
    //     shareContent:'学有所用，学有所得，最高10万U豆悬赏学习之星',
    //     shareAction: "",
    //     uniqueId: "",
    //     extendPrams: {},
    //   };

    //   const shareImg = 'https://www.hs.net/r/cms/www/openplatWeb/images/share-min.png';
    //   sharing({
    //     channel: "weixin",
    //     app_key: "",
    //     action: this.shareAction,
    //     unique_id: this.shareAction,
    //     params: {
    //       image: shareImg,
    //       title: shareParams.shareTitle,
    //       content: shareParams.shareContent,
    //       ...shareParams.extendPrams,
    //       url: `${window.LOCAL_CONFIG.onlineClassUrl}/banner-home/i/LearningStar-2022/#/`
    //     }
    //   }).then((res) => {
       
    //     if (res) {
    //        this.shareUrl = res.url
    //       // this.shareUrl = res.url.replace(
    //       //   /(.*)(?=s_id)/,
    //       //   location.origin + location.pathname + "?"
    //       // );
    //     }
    //   });
    // },
  },
  mounted() {
    this.getUserPoint();
    this.getPrizeList();
    // this.getShareLink();
    this.OnloadInviteRank();
  },
};
</script>
<style lang="scss" scoped>
.tab3 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  .left {
    width: 550px;
  }
  .right {
    width: 550px;
  }
}
.point-icon {
  background: #dce4ff;
  border: 2px solid rgba(92, 121, 230, 1);
  width: 8px;
  height: 8px;
  border-radius: 4px;
  flex-shrink: 0;
  margin: 7px 4px 7px 0;
}
.point-icon-sm {
  background: #dce4ff;
  border: 1px solid rgba(92, 121, 230, 1);
  width: 4px;
  height: 4px;
  margin: 9px 8px 7px 0;
  border-radius: 4px;
}
.square-bg {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #506fe9;
  border: 2px solid rgba(35, 64, 176, 1);
  margin-right: 8px;
}
.gift-top-bg {
  background: #f3f6ff;
  border: 1px solid rgba(35, 64, 176, 1);
  border-radius: 2px;
  margin-top: 20px;
  padding: 16px 20px 22px;
  position: relative;
}
.rule-title {
  font-family: AlibabaPuHuiTi-Regular;
  font-size: 16px;
  color: #5c79e6;
  text-align: left;
  display: flex;
}
.rule-title-dark {
  color: #2340b0;
}
.rule-number {
  font-family: AlibabaPuHuiTi-Regular;
  font-size: 20px;
  color: #2340b0;
  letter-spacing: 0;
  margin: 15px auto 10px;
  .number {
    color: #ff6800;
  }
}
.invitation-btn {
  background: #f0f0f0;
  // border: 1px solid rgba(35, 64, 176, 1);
  border-radius: 2px;
  position: absolute;
  right: 20px;
  bottom: 22px;
  width: 530px;
  height: 36px;
  font-size: 16px;
  color: #666666;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left-input {
    border: 1px solid rgba(35, 64, 176, 1);
    border-right: 0;
    height: 100%;
    flex: 1;
    line-height: 36px;
    padding: 0 10px;
    font-size: 16px;
    color: #666666;
    background-color: #f0f0f0;
    &:focus-visible {
      outline: none;
    }
  }
  .right-btn {
    background: #7998ff;
    border: 1px solid #2340b0;
    border-radius: 0 2px 2px 0;
    width: 121px;
    height: 100%;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
  }
}
.exchange-item {
  background: #f3f6ff;
  border: 1px solid rgba(35, 64, 176, 1);
  border-radius: 2px;
  height: 76px;
  width: 550px;
  margin: 0 auto 5px;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .number {
    color: #ff6800;
    &.disable {
      color: #999999;
      cursor: not-allowed;
    }
  }
  .btn {
    width: 100px;
    height: 36px;
    background: #ffd52d;
    border: 1px solid #2340b0;
    box-shadow: 1px 2px 0 0 #5c79e6, inset -2px -3px 0 0 #ff6800,
      inset 2px 2px 0 0 #ffffff;
    border-radius: 20px;
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 16px;
    color: #2340b0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &.disable {
      background: #cccccc;
      border: 1px solid #2340b0;
      box-shadow: 1px 2px 0 0 #5c79e6, inset 2px 2px 0 0 #ffffff;
      color: #ffffff;
    }
  }
}
.rank-list {
  max-height: 500px;
  overflow-y: auto;
  :deep(.van-list__error-text),
  :deep(.van-list__finished-text),
  :deep(.van-list__loading) {
    color: #2340b0;
    .van-loading__text,
    .van-list__loading-icon .van-loading__spinner {
      font-size: 24px;
      color: #2340b0;
    }
  }
}
.rule-sub-title {
  font-family: AlibabaPuHuiTi-Regular;
  font-size: 20px;
  color: #2340b0;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 10px;
  text-align: left;
  display: flex;
  margin-top: 16px;
  align-items: center;
}
.list-box {
  max-height: 276px;
  overflow-y: auto;
}
.rule-con {
  background: #f3f6ff;
  border: 1px solid rgba(35, 64, 176, 1);
  border-radius: 2.88px;
  height: 36px;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  font-family: AlibabaPuHuiTi-Regular;
  font-size: 16px;
  color: #2340b0;
  text-align: center;
  .col1 {
    flex: 1;
  }
  .col2 {
    flex: 1;
  }
  .highlight {
    color: #ff6800;
  }
}
.rule-con-title {
  background: #c4d0ff;
  height: 40px;
  // position: absolute;
  // width: 638px;
}
.rule-connect {
  font-family: AlibabaPuHuiTi-Regular;
  font-size: 24px;
  color: #dce4ff;
  letter-spacing: 0;
  text-align: center;
  line-height: 40px;
  font-weight: 400;
  margin-top: 6px;
  margin-bottom: 16px;
}
.no-data {
  width: 100%;
  background: #ffffff;
  border: 1px solid rgba(35, 64, 176, 1);
  border-radius: 2px;
  height: 316px;
  font-size: 20px;
  color: #5c79e6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-content {
  text-align: right;
  margin-top: 5px;

  /deep/ .h-page {
    font-size: 0;
  }
  /deep/ .h-page-item,
  /deep/ .h-page-item-jump-next,
  /deep/ .h-page-item-jump-prev {
    background: #f3f6ff;
    border: 1px solid rgba(35, 64, 176, 1);
    border-radius: 2.88px;
    min-width: 36px;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    a {
      font-size: 16px;
      color: #2340b0;
    }
    &::after {
      color: #2340b0;
    }
  }
  /deep/ .h-page-item-active {
    background: #c4d0ff;
    border: 1px solid rgba(35, 64, 176, 1);
    border-radius: 2.88px;
  }
  /deep/ .h-page-prev,
  /deep/ .h-page-next {
    background: #f3f6ff;
    border: 1px solid rgba(35, 64, 176, 1);
    border-radius: 2.88px;
    min-width: 36px;
    height: 36px;
    line-height: 36px;
    a {
      font-size: 16px;
      color: #2340b0;
    }
  }
  /deep/ .h-page-total {
    font-size: 16px;
    color: #2340b0;
    height: 36px; 
    line-height: 36px;
    vertical-align: bottom;
  }
  /deep/ .h-page-disabled {
    background-color: #f7f7f7;
    border-color: #ccc;
    a {
      color: #ccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/activities/learningStar/components/giftOfInvite.vue